<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const menuItems = [
  { path: '/', label: '仪表盘' },
  { path: '/users', label: '用户管理' },
  { path: '/apps', label: '应用审核' },
  { path: '/channels', label: '渠道管理' },
  { path: '/billing', label: '计费管理' },
]

const activePath = computed(() => route.path)

function navigate(path: string): void {
  router.push(path)
}
</script>

<template>
  <aside class="admin-sidebar">
    <nav class="admin-sidebar__nav">
      <div
        v-for="item in menuItems"
        :key="item.path"
        class="admin-sidebar__item"
        :class="{ 'admin-sidebar__item--active': activePath === item.path }"
        @click="navigate(item.path)"
      >
        {{ item.label }}
      </div>
    </nav>
  </aside>
</template>

<style scoped lang="scss">
.admin-sidebar {
  background-color: var(--aw-bg-base);
  border-right: 1px solid var(--aw-border-default);
  padding: var(--aw-space-2);

  &__nav {
    display: flex;
    flex-direction: column;
    gap: var(--aw-space-1);
  }

  &__item {
    display: flex;
    align-items: center;
    padding: var(--aw-space-2) var(--aw-space-3);
    border-radius: var(--aw-radius-md);
    cursor: pointer;
    transition: all var(--aw-duration-fast);
    color: var(--aw-text-secondary);
    font-size: var(--aw-text-sm);

    &:hover {
      background-color: var(--aw-bg-muted);
      color: var(--aw-text-primary);
    }

    &--active {
      background-color: var(--aw-primary-50);
      color: var(--aw-primary-600);
      font-weight: var(--aw-font-medium);
    }
  }
}
</style>
